(() => {
  const selector = {
    slider: '.productGallery__slider',
    productGallery: '.productGallery',
    header: '.section-header',
    videoHandler: '.js-toggle-video',
    video: '.productGallery__video',
    hiddenImage: '.productGallery__sliderImageWrapper.hide-image',
    productVideoWrapper: '.productGallery__videoWrapper',

    videoPlayButtonClass: 'productGallery__videoPlayButton',
    productVideoActive: 'productGallery__videoWrapper--active',
  }
  const header = document.querySelector(selector.header);
  const productGallery = document.querySelector(selector.productGallery);
  const hiddenImages = document.querySelectorAll(selector.hiddenImage);
  const videoHandlers = document.querySelectorAll(selector.videoHandler);
  const videos = document.querySelectorAll(selector.video);
  const slickSettings = {
    infinite: false,
    dots: true,
    arrows: false,
    autoplay: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 768,
        settings: 'unslick'
      },
    ],
  };

  hiddenImages.forEach((img) => {
    img.classList.remove('hide-image');
  });

  document.addEventListener('scroll', (e) => {
   if (header.classList.contains('scroll')){
      productGallery.style.top = "75px";
    } else {
      productGallery.style.top = "25px";
    }
  });

  function toggleVideo(e) {
    const target = e.currentTarget;

    if (window.innerWidth > 768) {
      const video = target.querySelector(selector.video) || target;
      const wrapper = target.classList.contains(selector.productVideoActive)
        ? target : target.closest(selector.productVideoWrapper);

      if (
        !e.target.classList.contains(selector.videoPlayButtonClass)
        && window.innerWidth < 768
      ) {
        return;
      }

      if (e.type === 'play' || e.type === 'click') {
        wrapper.classList.add(selector.productVideoActive);
        video.play();
        video.controls = true;
      } else if (e.type === 'pause' || e.type === 'click') {
        wrapper.classList.remove(selector.productVideoActive);
        video.pause();
        video.controls = false;
      }
    } else {
      const video = target.querySelector(selector.video);

      if (!e.target.classList.contains(selector.videoPlayButtonClass)) {
        return;
      }

      if (video.paused) {
        target.classList.add(selector.productVideoActive);
        video.play();
        video.controls = true;
      } else {
        target.classList.remove(selector.productVideoActive);
        video.pause();
        video.controls = false;
      }
    }
  }

  $(selector.slider).slick(slickSettings);

  window.addEventListener('resize', () => {
    $(selector.slider).slick('resize');
  });

  videoHandlers.forEach((videoHandler) => {
    videoHandler.addEventListener('click', toggleVideo);
  });

  videos.forEach((video) => {
    video.addEventListener('pause', toggleVideo);
    video.addEventListener('play', toggleVideo);
  });
})();
